export default {
  name: 'table-column-expandable',
  props: {
    value: {
      type: [Object, String, Number],
      default: null,
      required: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    extraItems: {
      type: Array,
      default () {
        return []
      }
    },
    stylingClasses: {
      type: Array,
      default: []
    }
  },
  data () {
    return {

    }
  }
}
